export class SyncProgressEvent {
  processed: number;
  totalThisRun: number;
  totalInDB: number;
  entity: SyncEntity;
  done: boolean;
  syncStage: SyncStage;

  constructor(processed: number, totalThisRun: number, totalInDB: number, entity: SyncEntity, done: boolean, syncStage: SyncStage) {
    this.processed = processed;
    this.totalThisRun = totalThisRun;
    this.totalInDB = totalInDB;
    this.entity = entity;
    this.done = done;
    this.syncStage = syncStage;
  }
}

type SyncEntity = 'Candidate' | 'ClientContact' | 'ClientCorporation';
export type SyncStage = 'INITIAL_SYNC' | 'INSERTING' | 'UPDATING' | 'DELETING' | 'COMPLETE';
